import clientsApi from '@/api/v1/clients';
import hrApi from '@/api/v1/hr';

export default {
  namespaced: true,

  state: {
    recruitmentData: {
      position: '',
      experience_in_years: '',
      level: '',
      rate: '',
      currency: '',
      start_date: '',
      end_date: '',
      management: [],
      technologies: [],
      project_areas: [],
      candidates: [],
      notes: '',
      attachments: [],
      id: '',
    },

    isDataLoading: false,
    isSubmitProcessing: false,
  },

  mutations: {
    CHANGE_RECRUITMENT(state, recruitmentData) {
      state.recruitmentData = { ...recruitmentData };
    },

    CHANGE_SUBMIT_STATUS(state, status) {
      state.isSubmitProcessing = status;
    },

    CHANGE_LOADING_STATUS(state, status) {
      state.isDataLoading = status;
    },

    CHANGE_NOTES(state, notes) {
      state.recruitmentData.notes = notes;
    },
  },

  actions: {
    fetchRecruitment({ commit }, recruitmentId) {
      commit('CHANGE_LOADING_STATUS', true);

      return new Promise((resolve, reject) => {
        clientsApi.recruitments
          .show(recruitmentId)
          .then((resp) => {
            commit('CHANGE_RECRUITMENT', resp.data);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    createRecruitment({ commit, dispatch, rootState }, recruitmentData) {
      commit('CHANGE_SUBMIT_STATUS', true);

      const api = rootState.auth.role === 'super_hr' ? hrApi : clientsApi;

      return new Promise((resolve, reject) => {
        api.recruitments
          .create(recruitmentData.projectId, recruitmentData.data)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_SUBMIT_STATUS', false);
          });
      });
    },

    updateRecruitment({ commit, dispatch }, recruitmentData) {
      commit('CHANGE_SUBMIT_STATUS', true);

      return new Promise((resolve, reject) => {
        clientsApi.recruitments
          .update(recruitmentData.id, recruitmentData)
          .then((resp) => {
            commit('CHANGE_RECRUITMENT', resp.data);
            dispatch('showSuccess', ['Updated'], { root: true });
            resolve();
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_SUBMIT_STATUS', false);
          });
      });
    },

    deleteRecruitment({ dispatch }, recruitmentId) {
      return new Promise((resolve, reject) => {
        clientsApi.recruitments
          .delete(recruitmentId)
          .then((resp) => {
            dispatch('showSuccess', ['Deleted'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject(err);
          });
      });
    },

    updateCandidateStatus({ dispatch }, candidate) {
      return new Promise((resolve, reject) => {
        clientsApi.candidates
          .updateStatus(candidate.id, candidate.status)
          .then((resp) => {
            dispatch('showSuccess', ['Status updated'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject(err);
          });
      });
    },

    addRecruitmentNotes({ commit }, notes) {
      commit('CHANGE_NOTES', notes);
    },
  },
};
